import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { PostalCodeJsonFile } from '../models/hrm-lookup.models';
import { BaseHrmLookupClient } from './base-hrm-lookup.client';

@Injectable({
  providedIn: 'root',
})
export class PostalCodesClient extends BaseHrmLookupClient<PostalCodesLookupItem> {
  protected override FILE_PATH = 'generated/postal-codes-norway.json';

  getPostalCodes(): Observable<PostalCodesLookupItem[]> {
    return this.getCachedOrFetch();
  }

  protected override mapFileToModel(data: PostalCodeJsonFile): PostalCodesLookupItem[] {
    const result: PostalCodesLookupItem[] = [];

    for (const [code, area] of Object.entries(data.postalCodes)) {
      const mappedItem: PostalCodesLookupItem = {
        code,
        area,
      };

      result.push(mappedItem);
    }

    return result;
  }
}

export type PostalCodesLookupItem = {
  code: string;
  area: string;
};
